import { useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addMessage,
  removeMessage,
  selectSnackbarsCount,
  SNACKBAR_LIMIT,
  removeFirstMessage
} from '@urc-ui/store/slices/snackbar/snackbarSlice';
import { SnackbarType, SnackbarMessage } from '@urc-ui/store/slices/snackbar/types';

export const useRemoveSnackbar = (snackbar: SnackbarType, config?: { duration: number }) => {
  const snackbarDuration = config?.duration || 5000;
  const dispatch = useDispatch();
  const SNACKBAR_TIMER = useRef<ReturnType<typeof setTimeout>>();

  const handleTimeout = useCallback(() => {
    SNACKBAR_TIMER.current = setTimeout(() => {
      dispatch(removeMessage(snackbar.id));
    }, snackbarDuration);
  }, [dispatch, snackbar.id, snackbarDuration]);

  const handleClose = useCallback(() => {
    clearTimeout(SNACKBAR_TIMER.current);
    dispatch(removeMessage(snackbar.id));
  }, [dispatch, snackbar.id]);

  useEffect(() => {
    handleTimeout();
  }, [handleTimeout]);

  return { handleClose };
};

export const useAddSnackbar = () => {
  const dispatch = useDispatch();
  const snackbarsCount = useSelector(selectSnackbarsCount);
  const addSnackbar = useCallback(
    (snackbarMessage: SnackbarMessage) => {
      // Only add up to three snackbars at a time
      if (snackbarsCount === SNACKBAR_LIMIT) {
        dispatch(removeFirstMessage());
      }
      return dispatch(addMessage(snackbarMessage));
    },
    [snackbarsCount]
  );
  return { addSnackbar };
};
